











































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateBuyCardRecord from "./create-buyCardRecord.vue";

class PagecouponRequest extends PageRequest {
  mobile: "";
  name: "";
}

@Component({
  components: {CreateBuyCardRecord},
})
export default class coupons extends AbpBase {
  // 编辑按钮事件处理
  edit() {
    this.editModalShow = true;
  }
  //请求过滤参数
  pagerequest: PagecouponRequest = new PagecouponRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
    return this.$store.state.buyCardRecord.list;
  }

  get loading() {
    return this.$store.state.buyCardRecord.loading;
  }
  create() {
    this.createModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("buyCardRecord/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("buyCardRecord/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("buyCardRecord/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "buyCardRecord/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.buyCardRecord.pageSize;
  }

  get totalCount() {
    return this.$store.state.buyCardRecord.totalCount;
  }

  get currentPage() {
    return this.$store.state.buyCardRecord.currentPage;
  }
  columns = [
    {
      title: "姓名",
      key: "name",
    },
    {
      title: "手机号",
      key: "mobile",
    },
    {
      title: "性别",
      key: "sex",
      render: (h: any, params: any) => {
        return h("span", params.row.sex == 1 ? "男" : "女");
      },
    },
    {
      title: "是否已支付",
      key: "isPaid",
      render: (h: any, params: any) => {
        return h("span", params.row.isPaid ? "是" : "否");
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.creationTime).toLocaleString());
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      align: "center",
      slot: "action",
      render: (h: any, params: any) => {
        // this.hasPermission("Pages.Coupon.Delete")
        if (true) {
          return h("div", [
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: this.L("Tips"),
                      content: "确定要删除该记录吗",
                      okText: this.L("Yes"),
                      cancelText: this.L("No"),
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "buyCardRecord/delete",
                          data: params.row,
                        });
                        await this.getpage();
                      },
                    });
                  },
                },
              },
              "删除"
            ),
          ]);
        }
      },
    },
  ];
  async created() {
    this.getpage();
  }
}
